export interface OracleQuoteInfo {
    oracleAccount: string;
    baseMint: string;
    lastUpdateTime: number;
    spotPrice: number;
    twapPrice: number;
    marketPrice?: number;
    uncertainty: number;
    nowTimestamp: number;
}

export enum UncertaintyType {
    Skip,
    Add,
    Subtract
}

export interface OracleQuote {
    usdPrice: number;
    marketPrice: number;
    oracleAccount: string;
    getUsdAmount: <T extends number | undefined>(amount: T, decimals?: number, uncertaintyType?: UncertaintyType) => T;
    baseQuotes: OracleQuoteInfo[];
    uncertainty: number;
}

export enum OracleType {
    PythLegacy = 0,
    StakePoolLST = 1,
    MeteoraLP = 2,
    MeteoraVault = 3,
    SwitchboardPull = 4,
    OrcaWhirlpool = 5,
    Pyth = 6,
    Flp = 7,
    LoopscaleVaultLp = 8,
    ExponentToken = 9,
    StabbleLpToken = 10,
    PerenaLpToken = 11,
    RatexPtToken = 12,
    AdrenaLpToken = 13,
    EtherFuseStableBond = 14,
    // Fx oracle type is used for pricing other tokens that need FX rates only. Currently not used as standalone oracle type.
    // It is also a pyth oracle type, just without a real token attached.
    // It is also inverted.
    Fx = 15,
    RaydiumCLMM = 16
}

//Markets oracle
export interface TxnCreateMarketInformationParams {
    principalMint: string;
}

export interface TxnUpdateMarketInformationParams {
    marketInformation: string;
    authority: string;
    assetIdentifier: string;
    quoteMint?: string;
    oracleAccount?: string;
    oracleType?: OracleType;
    maxUncertainty?: number;
    maxAge?: number;
    decimals?: number;
    ltv?: number;
    liquidationThreshold?: number;
    remove?: boolean;
}
